import { render, staticRenderFns } from "./ProgressStarIcon.vue?vue&type=template&id=7c6b2604&"
import script from "./ProgressStarIcon.vue?vue&type=script&lang=js&"
export * from "./ProgressStarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports